import React, { useEffect, useState } from 'react';
import { Button, Dialog, Divider, List, ListItemButton, Tooltip } from '@mui/material';
import axios from 'axios';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import classes from './ScheduleSend.module.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment-timezone';
import { boxiPrimary } from '../../../../assets/style/colors';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LoadingButton } from '@mui/lab';
import { useToastContext } from "../../../../wrappers/ToastContext";

const ScheduledMessages = ({ isModalOpen, openModal }) => {
  const { toast } = useToastContext();

  const [isScheduledMessagesLoading, setIsScheduledMessagesLoading] = useState(false);
  const [scheduledMessages, setScheduledMessages] = useState([]);
  const [messageToUpdate, setMessageToUpdate] = useState(null);
  const [messageToDelete, setMessageToDelete] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [schedule, setSchedule] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleteAlertOn, setIsDeleteAlertOn] = useState(false);
  const [isMessageUpdating, setIsMessageUpdating] = useState(false); 
  const [isMessageDeleting, setIsMessageDeleting] = useState(false); 
  const [scheduledFor, setScheduledFor] = useState(null);

  useEffect(() => {
    fetchScheduledMessages();
  }, []);

  const fetchScheduledMessages = async () => {
    try {
      setIsScheduledMessagesLoading(true);
      setSchedule(null);
      setScheduledFor(null);
      setIsUpdating(false);
      setMessageToDelete(null);
      setMessageToUpdate(null);
      setSelectedMessage(null);
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/scheduled_messages`);
      setScheduledMessages(res.data.scheduledMessages);
      setIsScheduledMessagesLoading(false);
    } catch (error) {
      setIsScheduledMessagesLoading(false);
      console.log(error);
      toast.error(error?.response?.data?.message);
    }
  }

  const generateAvatarBackgroundColor = (name) => {
    let numericValue = 0;
    for (let i = 0; i < name.length; i++) {
      numericValue += name.charCodeAt(i);
    }
    const hue = numericValue % 360; // Use modulo to restrict the hue to a range of 0-359
    const saturation = 70; // Set a fixed saturation value
    const lightness = 50; // Set a fixed lightness value
    const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    return color;
  };

  const updateScheduledMessage = async () => {
    try {
      setIsMessageUpdating(true);
      const res = await axios.patch(`${process.env.REACT_APP_API_HOST}/communication/update_scheduled_message`, { sid: JSON.parse(messageToUpdate.twilio_meta).sid, schedule  });
      await fetchScheduledMessages();
      setIsMessageUpdating(false);
    } catch (error) {
      console.log('error >>>>>', error.response);
      setIsMessageUpdating(false);
      toast.error(error?.response?.data?.message);
    }
  }

  const deleteScheduledMessage = async () => {
    try {
      setIsMessageDeleting(true);
      const res = await axios.delete(`${process.env.REACT_APP_API_HOST}/communication/delete_scheduled_message/${JSON.parse(messageToDelete.twilio_meta).sid}`);
      await fetchScheduledMessages();
      setIsMessageDeleting(false);
      setIsDeleteAlertOn(false);

    } catch (error) {
      setIsMessageDeleting(false);
      console.log(error);
      toast.error(error?.response?.data?.message);
    }
  }

  useEffect(() => {
    setScheduledFor(moment.tz(messageToUpdate?.scheduled_for, 'America/Los_Angeles'));
  }, [messageToUpdate])

  return (
    <>
      <Modal backdrop="static" className={classes.wideModalDialog} isOpen={isModalOpen} toggle={() => openModal(false)}>
        <ModalHeader toggle={() => openModal(false)}>Scheduled Messages</ModalHeader>
        <ModalBody style={{ minHeight: 300 }}>
          {(isScheduledMessagesLoading || isMessageUpdating) && <div className={classes.loaderOverlay}>
            <Spinner style={{ color: boxiPrimary }} />
          </div>}
          {!isScheduledMessagesLoading && <div>
            {scheduledMessages.length === 0 ?
              <div style={{ color: 'rgb(130 130 130)', fontSize: 14, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>No scheduled messages found!</div>
              :
              <Row style={{ maxHeight: 'inherit', minHeight: 'inherit', marginTop: '-1rem', marginBottom: '-1rem' }}>
                <Col sm="4" id="infinite-scroll-container" style={{ padding: 0, borderRight: '1px solid #ccc', maxHeight: 'inherit', minHeight: 'inherit', overflow: 'auto' }}>
                  <List sx={{ width: '100%', paddingTop: '4px', paddingBottom: '4px' }} component="nav" aria-label="vendor-options">
                    <InfiniteScroll
                      dataLength={10}
                      next={() => console.log('hello')}
                      hasMore={false}
                      loader={false && <div style={{ margin: '10px auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
                      height={300}
                    >
                      {scheduledMessages && scheduledMessages.length > 0 && scheduledMessages.map((message, index) => (
                        <>
                          <ListItemButton selected={message.id === selectedMessage?.id} sx={{ columnGap: '10px', cursor: 'pointer', }}>
                            {/* <Tooltip placement="top" title={`${message.body} - ${moment.tz(message.scheduled_for, 'America/Los_Angeles').format('MM/DD hh:mm A')}`}>
                            </Tooltip> */}
                              <div className={`d-flex ${classes.contactCard}`} style={{ cursor: 'pointer', columnGap: 10, flexGrow: 1 }}>
                                <div className={classes.picture} style={{ backgroundColor: generateAvatarBackgroundColor(message.name ? message.name : message.phone_number) }}>
                                  {!message.name ? <PersonIcon /> : message.name.trim().split(' ').slice(0,2).reduce((acc, name) => acc+name[0],'')}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', columnGap: 10, flexGrow: 1 }}>
                                  <div className="overflow-hidden" onClick={() => { setSelectedMessage(message); setMessageToUpdate(null); setIsUpdating(false); }}>
                                    <div className="overflow-hidden text-truncate" style={{fontSize: '15px', fontWeight: '500'}}>{message.name ? message.name : message.phone_number}</div>
                                    <div className="overflow-hidden text-truncate" style={{fontSize: '12px', width: 210}}>{message.body}</div>
                                  </div>
                                  <div style={{ display: 'flex', justifyContent: 'center', rowGap: 7, flexDirection: 'column', zIndex: 99999, position: 'absolute', right: 16 }}>
                                    <div className="d-flex justify-content-end" style={{ columnGap: 10 }}>
                                      <EditIcon onClick={() => { setMessageToUpdate(message); setIsUpdating(true); setMessageToDelete(null); setSelectedMessage(null); }} fontSize='16' color='primary' />
                                      <DeleteIcon onClick={() => { setMessageToUpdate(null); setMessageToDelete(message); setSelectedMessage(null); setIsDeleteAlertOn(true); }} fontSize='16' color='error' />
                                    </div>
                                    <div className="d-flex align-items-center align-self-end">
                                      <div style={{fontSize: '12px'}}>{moment.tz(message.scheduled_for, 'America/Los_Angeles').format('MM/DD hh:mm A')}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </ListItemButton>
                          <Divider />
                        </>
                      ))}
                    </InfiniteScroll>
                  </List>
                </Col>
                <Col sm="8" style={{ maxHeight: 'inherit', minHeight: 'inherit', overflow: 'auto' }}>
                  {selectedMessage && !messageToUpdate && !messageToDelete && <div className={classes.selectedTemplateContainer}>
                    <div>To<br /><span>{selectedMessage.name ? selectedMessage.name : selectedMessage.phone_number}</span></div><br />
                    <div>Message Body<br /><span dangerouslySetInnerHTML={{__html: selectedMessage.body.replace(/\n/g, '<br>')}}></span></div><br />
                    <div>Scheduled For<br /><span>{moment.tz(selectedMessage.scheduled_for, 'America/Los_Angeles').format('MMMM Do')} at {moment.tz(selectedMessage.scheduled_for, 'America/Los_Angeles').format('hh:mm A')}</span></div>
                    <div>Scheduled By<br /><span>{selectedMessage.sender_name}</span></div>
                  </div>}
                  {messageToUpdate && isUpdating && scheduledFor && 
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DemoContainer
                        components={[
                          'MobileDateTimePicker'
                        ]}
                      >
                        <DemoItem label="Select Schedule Time">
                          <MobileDateTimePicker maxDateTime={moment.tz('America/Los_Angeles').add(7, 'days')} minDateTime={moment.tz('America/Los_Angeles').add(20, 'minutes')} onChange={(e) => setSchedule(e.toISOString())} value={scheduledFor} />
                        </DemoItem>
                      </DemoContainer>
                    </LocalizationProvider>
                  }
                </Col>
              </Row>
            }
          </div>}
        </ModalBody>
        {messageToUpdate && <ModalFooter>
          <Button color="primary" disabled={!schedule} onClick={() => updateScheduledMessage()}>
            Update
          </Button>
          <Button color="secondary" onClick={() => { setIsUpdating(true); setMessageToUpdate(null); }}>
            Cancel
          </Button>
        </ModalFooter>}
      </Modal>

      <Dialog onClose={() => setIsDeleteAlertOn(false)} open={isDeleteAlertOn} className="deleteAlertDialog">
        <div>This action will permanently delete this schedule message. Are you sure you want to continue?</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', columnGap: 10 }}>
          <LoadingButton loading={isMessageDeleting} disabled={isMessageDeleting} color="error" onClick={() => deleteScheduledMessage()}>
            Delete
          </LoadingButton>
          <Button color="secondary" disabled={isMessageDeleting} onClick={() => setIsDeleteAlertOn(false)}>
            Cancel
          </Button>
        </div>
      </Dialog>
    </>
  )
}

export default ScheduledMessages;